/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/axios/~/is-buffer/index.js
 ** module id = 732
 ** module chunks = 1
 **/